export const apiPath = '/v2/digital_forms';
const actionType = 'DIGITAL_FORMS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
